<template>
    <div class="jump-warp">
        <van-nav-bar title="积分商城" left-arrow fixed
                     @click-left="back">
        </van-nav-bar>
        <van-swipe class="jump-swipe" :autoplay="3000">
            <van-swipe-item v-for="item in swipeImgs">
                <a :href="item.ad_url==''?'javascript:void(0);':item.ad_url==null?'javascript:void(0);':item.ad_url=='#'?'javascript:void(0);':item.ad_url"><img
                        :src="item.pic_url"></a>
            </van-swipe-item>
        </van-swipe>
        <!-- <van-notice-bar
          text="聚牧城关于19年春节期间商品发运工作通知"
          left-icon="volume-o"
          :scrollable="false"
          class="jump-notice"
        /> -->
        <van-row class="jump-menu-hd">
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=5">
                 <span class="icon-hd bg-pink"><i class="iconfont icon-yaopin"></i></span>
                    <!-- <span ><img class="homeimg" src="@/assets/homeimg/cangku.png"/></span> -->
                    <span>兽药</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=6">
                    <!-- <span class="icon-hd bg-purple"><i class="iconfont icon-yaopin"></i></span> -->
                    <span class="icon-hd bg-purple"><img class="homeimg" src="@/assets/homeimg/add.png"/></span>
                    <span>添加剂</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=12">
                    <span class="icon-hd bg-yellow"><i class="iconfont icon-jiediancuxiao"></i></span>
                    <!-- <span ><img class="homeimg" src="@/assets/homeimg/veterinaryDrugs.png"/></span> -->
                    <span>疫情防护专区</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=8">
                   <span class="icon-hd bg-green"><i class="iconfont icon-ziyuan"></i></span>
                    <!-- <span ><img class="homeimg" src="@/assets/homeimg/ranchSupplies.png"/></span> -->
                    <span>牧场耗品</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=9">
                   <!-- <span class="icon-hd bg-cyan"><i class="iconfont icon-cangku"></i></span> -->
                    <span class="icon-hd bg-cyan"><img class="homeimg" src="@/assets/homeimg/qixie.png"/></span>
                    <span>器械</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=10">
                   <span  class="icon-hd bg-blue"><i class="iconfont icon-fenleigongnengleimu"></i></span>
                    <!-- <span ><img class="homeimg" src="@/assets/homeimg/integralShop.png"/></span> -->
                    <span>检测用品</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=11">
                    <!-- <span class="icon-hd bg-orange"><i class="iconfont icon-yaopin"></i></span> -->
                    <span class="icon-hd bg-orange"><img class="homeimg" src="@/assets/homeimg/jixie.png"/></span>
                    <span>机械设备</span>
                </a>
            </van-col>
            <van-col span="6" class="jump-menu">
                <a href="#/integral/goodlist?categoryId=4">
                  <!-- <span class="icon-hd bg-red"><i class="iconfont icon-yaopin"></i></span> -->
                    <span class="icon-hd bg-red"><img class="homeimg" src="@/assets/homeimg/E.png"/></span>
                    <span>京东E卡</span>
                </a>
            </van-col>
        </van-row>
        <div class="jump-hot-item" v-if="topData.animalDrugs.length > 0">
            <h5>兽药<a href="#/integral/goodlist?categoryId=5" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.animalDrugs">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>
        <div class="jump-hot-item" v-if="topData.annexingAgent.length > 0 ">
            <h5>添加剂<a href="#/integral/goodlist?categoryId=6" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.annexingAgent">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>
        <div class="jump-hot-item" v-if="topData.monitor.length > 0">
            <h5>检测用品<a href="#/integral/goodlist?categoryId=10" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.monitor">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>
        <div class="jump-hot-item" v-if="topData.jdcomEK.length>0">
            <h5>京东E卡<a href="#/integral/goodlist?categoryId=4" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.jdcomEK">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>

        <div class="jump-hot-item" v-if="topData.sectionOne.length>0">
            <h5>0-1999分<a href="#/integral/goodlist?seach=1" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.sectionOne">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>

        <div class="jump-hot-item" v-if="topData.sectionTwo.length>0">
            <h5>2000-3999分<a href="#/integral/goodlist?seach=2" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.sectionTwo">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>

        <div class="jump-hot-item" v-if="topData.sectionThree.length>0">
            <h5>4000-5999分<a href="#/integral/goodlist?seach=3" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.sectionThree">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>
        <div class="jump-hot-item" v-if="topData.sectionFore.length>0">
            <h5>6000分以上<a href="#/integral/goodlist?seach=4" style=" float: right;padding-right: 10px;">更多</a></h5>
            <van-row gutter="10">
                <van-col span="8" v-for="item in topData.sectionFore">
                    <a :href="'#/integral/gooddetail/'+item.id">
                        <p>{{item.name}}</p>
                        <img :src="item.imges">
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:14px">{{item.integral}}分</p>
                        <p style="color: #ff921d;text-align: left;padding-left: 5px;height:20px;font-size:13px">所属等级:{{item.levelName}}</p>
                    </a>
                </van-col>
            </van-row>
        </div>


    </div>
</template>
<script>
    import {
        NavBar,
        Swipe,
        SwipeItem,
        Row,
        Col,
        Tabbar,
        TabbarItem,
        NoticeBar
    } from "vant";

    export default {
        name: "integralhome",
        components: {
            [NavBar.name]: NavBar,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Row.name]: Row,
            [Col.name]: Col,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [NoticeBar.name]: NoticeBar
        },
        data() {
            return {
                tabActive: 0,
                headerFixedBg: false,
                q: '',
                swipeImgs: [],
                topData: {
                    supermarket: [],
                    completeProduct: [],
                    rawMaterial: [],
                    virtualGoods: [],
                    animalDrugs:[],
                    annexingAgent:[],
                    monitor:[],
                    jdcomEK:[],
                    sectionOne:[],
                    sectionTwo:[],
                    sectionThree:[],
                    sectionFore:[],
                }
            };
        },
        methods: {
            back() {
                // history.back()
                this.$router.push('/home')
            },
        },
        mounted() {
            let that = this;
            that.$api.get(that.jumuc.integral.top3, {},
                successRes => {
                    that.topData = successRes.data;
                })
            that.$api.get(that.jumuc.integral.getIntegralTopBanner, {},
                successRes => {
                    that.swipeImgs = successRes.data;
                })
        },
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;
    .van-nav-bar {
        z-index: 100000;
    }

    .jump {
        &-warp {
            padding-bottom: 60px;
            background-color: #f7f7f7;
        }
        &-header {
            position: fixed;
            top: 46px;
            left: 0px;
            width: 100%;
            padding: 5px 0;
            background-color: transparent;
            z-index: 9999;
            &.fixed-bg {
                background-color: none;
            }
        }
        &-navbar {
            &-search {
                padding-left: 12px;
                .form-group {
                    margin-bottom: 0;
                    position: relative;
                    i {
                        position: absolute;
                        top: 6px;
                        right: 10px;
                        font-size: 12px;
                        color: @bule-thame;
                    }

                    input {
                        border-radius: 15px;
                        padding-right: 35px;
                    }
                }
            }
            &-arrow {
                text-align: center;
                line-height: 40px;
                i.van-icon {
                    font-size: 24px;
                    color: #ffffff;
                    vertical-align: -6px;
                }
            }
        }
        &-notice {
            color: #fff;
            background-color: @bule-thame;
        }
    }

    .jump-swipe {
        height: 187px;
        margin-top: 0px !important;
        //margin-top: 48px;
        img {
            width: 100%;
            min-height: 190px;
            display: block;
        }
    }

    .van-icon-contact {
        position: fixed;
        top: 10px;
        right: 15px;
    }

    .jump-menu-hd {
        padding: 10px 0;
        margin-bottom: 10px;
        background-color: #fff;
        .jump-menu {
            padding: 5px;
            font-size: 12px;
            text-align: center;

            span {
                display: block;
                margin-top: 5px;
                &.icon-hd {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    display: inline-block;
                    border-radius: 50%;
                    background-color: #ff7300;
                }
            }
            i.iconfont {
                color: #fff;
                font-size: 20px;
                vertical-align: -4px;
            }
            a {
                display: block;
            }
            .homeimg{
                width: 44px;
                height: 44px;
                line-height: 44px;
                display: inline-block;
                margin-bottom: 8px;
            }
        }
    }

    .jump-hot-item {
        margin-bottom: 10px;
        img {
            display: block;
            margin-left: auto;
            margin-right: auto;
            max-width: 100%;
            height: auto;
            width:112px!important;
            height:112px!important;
        }
        h5 {
            font-size: 14px;
            padding-left: 10px;
            border-left: 5px solid @bule-thame;
            margin-bottom: 10px;
            margin-top: 10px;
        }
        .van-col {
            margin-bottom: 10px;
            p {
                text-align: center;
                font-size: 14px;
                height: 40px;
                overflow:hidden;
            }
            a {
                display: block;
                padding: 10px 0;
                background-color: #fff;
            }
        }
        .van-col:nth-of-type(2) {

        }
    }

    .jump-hot,
    .jump-ad,
    .jump-featured {
        margin-bottom: 10px;
        img {
            display: block;
            margin-left: auto;
            margin-right: auto;
            max-width: 100%;
            height: auto;
        }
    }

    .jump-featured {
        &-head {
            padding: 10px 0;
            text-align: center;
            h5 {
                display: inline;
                font-size: 12px;
                position: relative;
                color: #ff8b00;
            }
        }
        &-body {
            div {
                height: 185px;
                padding: 10px;
                border-right: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
            }
            div:nth-child(-n + 3) {
                border-top: 1px solid #eeeeee;
            }
            a {
                color: #666;
            }
            h5 {
                line-height: 30px;
                font-size: 12px;
                margin: 0;
            }
            h6 {
                font-weight: normal;
                color: #999;
            }
        }
    }
    .icon-hd>img{
        width: 20px!important;
    height: 20px!important;
    vertical-align: -13px!important;
    }

</style>
